type InspectFlowResponseIconProps = {
    tone: 'ok' | 'warn' | 'inop' | 'na';
};

export const InspectFlowResponseIcon = ({ tone }: InspectFlowResponseIconProps) => {
    switch (tone) {
        case 'ok':
            return (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="inspect-flow-response-icon-svg">
                    <path
                        d="M8.5 12.5l2.5 2.5 4.5-5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                </svg>
            );
        case 'warn':
            return (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="inspect-flow-response-icon-svg">
                    <path
                        d="M12 5.5 20.5 19H3.5L12 5.5Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinejoin="round"
                    />
                    <path d="M12 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="12" cy="17" r="1" fill="currentColor" />
                </svg>
            );
        case 'inop':
            return (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="inspect-flow-response-icon-svg">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                    <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            );
        case 'na':
            return <span className="inspect-flow-response-icon-na-text">N/A</span>;
    }
};
